module.exports = __webpack_public_path__ + "img/ki.ki93b60ad.svg";